import StarFeatured from './StarFeatured'

export default function Badge({ hasHeading = true }) {
    return (
        <div>
            <div className="mx-auto w-full md:-mt-20 md:w-auto text-center">
                <div className="py-4 md:py-10 px-4 md:px-6">
                    {hasHeading && (
                        <div className="inline-flex space-x-4 justify-center">
                            <div className="text-xs font-semibold text-olm tracking-wide uppercase">
                                <div className="bg-olm-gradient-t-to-b rounded-full p-[2px] inline-block">
                                    <div className="px-2.5 py-1 bg-white rounded-full">
                                        Trusted by Service Pros & Investors
                                        Nationwide
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="mt-4">
                        {hasHeading && (
                            <h3 className="text-3xl md:text-5xl font-semibold text-black tracking-tight max-w-6xl mx-auto">
                                Powering Real Estate & Home Service Teams
                            </h3>
                        )}

                        <p className="mt-4 text-olm-new-black font-semibold text-lg max-w-5xl mx-auto">
                            Proven by thousands of investors, agents, roofers,
                            contractors, and service-based businesses
                        </p>

                        <div className="mt-6 w-full flex justify-center">
                            <div className="p-3 bg-orange-200 rounded-full">
                                <div className="bg-orange-50 border-orange-500 p-2 md:px-10 rounded-full inline-flex items-center">
                                    <StarFeatured size="h-10 w-10" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mx-auto max-w-5xl px-4 md:px-0">
                <img
                    src="https://admin.openlettermarketing.com/wp-content/uploads/2025/10/Features.png"
                    className="mx-auto w-full"
                    alt="Platform Features"
                    title="Platform Features"
                />
            </div>
        </div>
    )
}
